export const messages = {
  title: { id: 'admin/promotions.form.conditions.cluster' },
  subtitle: { id: 'admin/promotions.form.conditions.cluster.subtitle' },
  moreInformation: {
    id: 'admin/promotions.links.cluster.editor',
  },
  operator: {
    ariaLabel: {
      id: 'admin/promotions.form.conditions.cluster.operator.aria-label',
    },
    all: { id: 'admin/promotions.form.conditions.cluster.operator.all' },
    any: { id: 'admin/promotions.form.conditions.cluster.operator.any' },
  },
  entryAriaLabel: {
    id: 'admin/promotions.form.conditions.cluster.entry.aria-label',
  },
  add: { id: 'admin/promotions.utils.add' },
  remove: { id: 'admin/promotions.utils.remove' },
  create: { id: 'admin/promotions.utils.create' },
  discard: { id: 'admin/promotions.utils.discard' },
  save: { id: 'admin/promotions.utils.save' },
  cancel: { id: 'admin/promotions.utils.cancel' },
  view: {
    title: {
      id: 'admin/promotions.form.conditions.cluster.view.title',
    },
  },
  validation: {
    required: { id: 'admin/promotions.form.validation.required' },
    unique: {
      id: 'admin/promotions.form.conditions.cluster.validation.unique',
    },
    operator: {
      id: 'admin/promotions.form.conditions.cluster.validation.expression.operator',
    },
    equals: {
      id: 'admin/promotions.form.conditions.cluster.validation.expression.equals',
    },
    contains: {
      id: 'admin/promotions.form.conditions.cluster.validation.expression.contains',
    },
  },
}
